import houseInsure from './houseInsure.jpg'
import takeLoan from './takeLoan.jpg'
import applyOnline from './applyOnline.jpg'
import callSupport from './callSupport.jpg'
import deposit from './deposit.jpg'

const loanIMG = {
  houseInsure: houseInsure,
  takeLoan: takeLoan,
  applyOnline: applyOnline,
  callSupport: callSupport,
  deposit: deposit,
};

export default loanIMG;